module.exports = __webpack_public_path__ + "img/shareLinkWhite.4608c04d.svg";